// Components
import {Icon} from '@drivesally/sally-ui';

const Spinner = Icon;

export default Spinner;
